import {ReactNode} from 'react';

type FormInputProps<G> = Omit<
  G,
  'onChange' | 'value' | 'isActive' | 'isSelected' | 'handleClick' | 'checked' | 'selectedValue'
> & {
  name: string;
  onChange?: (G & Record<string, unknown>)['onChange'];
  onToggle?: (G & Record<string, unknown>)['onToggle'];
  handleClick?: (G & Record<string, unknown>)['handleClick'];
  label?: ReactNode;
  required?: boolean;
  formInputClassName?: string;
  labelClassName?: string;
  help?: ReactNode;
  errorType?: ErrorShowingType;
  initialTouched?: boolean;
  validationErrorClassName?: string;
};

enum FormLayout {
  Horizontal,
  Vertical,
}

enum ErrorShowingType {
  Message,
  Border,
}

export {FormInputProps, FormLayout, ErrorShowingType};
